import { StatisticCardData } from '../../types/interfaces/statistic-card-data';
import { Box } from '@mui/material';
import StatisticCard from '../molecules/statistic-card';

type Props = {
  data: StatisticCardData[];
};

const COLUMNS = 4;

export default function StatisticsSummaryPanel({ data = [] }: Props) {
  const fullRows = Math.floor(data.length / COLUMNS);
  const fullRowItems = data.slice(0, fullRows * COLUMNS);
  const lastRowItems = data.slice(fullRows * COLUMNS);

  return (
    <>
      <Box
        sx={{
          width: '100%',
          paddingTop: 4,
          paddingBottom: 2,
          paddingX: 0,
          display: 'grid',
          gridTemplateColumns: `repeat(${COLUMNS}, 1fr)`,
          gap: 2,
          alignItems: 'stretch',
        }}>
        {fullRowItems.map(({ type, count }) => {
          return (
            <StatisticCard
              key={`${type}-${count}`}
              type={type}
              count={count}
              sx={{
                gridColumn: 'auto',
              }}
            />
          );
        })}
      </Box>
      {lastRowItems.length > 0 && (
        <Box
          sx={{
            width: '100%',
            paddingX: 0,
            display: 'flex',
            gap: 2,
            paddingBottom: 4,
          }}>
          {lastRowItems.map(({ type, count }) => {
            return (
              <StatisticCard
                key={`${type}-${count}`}
                type={type}
                count={count}
                sx={{
                  flex: 1,
                }}
              />
            );
          })}
        </Box>
      )}
    </>
  );
}
